import React, { useState } from "react";
import backgroundImage from "../../assets/bg-1.png";
import productBg from "../../assets/product-bg.png";
import academicBg from "../../assets/academic-bg.png";
import trainingBg from "../../assets/training-bg.png";
import consultingBg from "../../assets/consulting-bg.png";
import incubationBg from "../../assets/incubation.png";
import workforceBg from "../../assets/workforce.png";
import holdingsBg from "../../assets/holdings.png";

import { ArrowUpRight } from "lucide-react";
import star from "../../assets/star.svg";
import halfStar from "../../assets/half-star.svg";
import emprtyStar from "../../assets/empty-star.svg";
import { motion } from "framer-motion";
import ContactModal from "../shared/ContactModal";

const RatingStars = ({ rating }) => {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }).map((_, index) => {
        const starValue = index + 1;
        if (rating >= starValue) {
          return (
            <img key={index} src={star} alt="full star" className="w-4 h-4" />
          );
        } else if (rating >= starValue - 0.5) {
          return (
            <img
              key={index}
              src={halfStar}
              alt="half star"
              className="w-4 h-4"
            />
          );
        } else
          return (
            <img
              key={index}
              src={emprtyStar}
              alt="empty star"
              className="w-4 h-4"
            />
          );
      })}
    </div>
  );
};

export const Card = ({ title, description, type, rating, url }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleKnowMore = () => {
    if (!url) {
      setIsModalOpen(true);
    } else if (url.startsWith("http")) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  };

  const bgImage = {
    agent: backgroundImage,
    product: productBg,
    academic: academicBg,
    training: trainingBg,
    consulting: consultingBg,
    incubation: incubationBg,
    workforce: workforceBg,
    subsidiaries: holdingsBg,
  };

  return (
    <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <motion.div
        className="flex-shrink-0 w-[313px] border-[1.6px] border-[#E9E9E9] rounded-xl flex flex-col"
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
      >
      <div className="w-full h-[160px] relative">
        <img
          src={bgImage[type]}
          alt="background"
          className="rounded-t-xl w-full h-full object-cover"
        />
        <h3
          className="w-[20ch] absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 
               text-2xl font-semibold text-[#414141] text-center px-4"
        >
          {title}
        </h3>
      </div>
      <div className="p-6 flex flex-col justify-between gap-5 flex-1">
        <div className="flex flex-col gap-5">
          <div className="flex justify-between items-center">
            <RatingStars rating={rating} />
            {/* <div className="flex justify-center items-center gap-1">
              <img src={eye} alt="view icon" className="w-4 h-4" />
              <span className="text-[#333333] font-medium text-base">
                {views}
              </span>
            </div> */}
          </div>
          <p className="text-[#5B5B5B] text-base">{description}</p>
        </div>
        <button 
          onClick={handleKnowMore}
          className="mt-3 w-full bg-[#243D86] text-white rounded-full flex justify-center items-center gap-0.5 py-2"
        >
          <span className="text-sm font-semibold">Know More</span>
          <ArrowUpRight className="size-5" />
        </button>
      </div>
    </motion.div>
    </>
  );
};
